"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const ui_state_1 = tslib_1.__importDefault(require("../utils/ui-state"));
class RecorderUiState extends ui_state_1.default {
    constructor() {
        super();
        /**
         * Indicates whether the recorder is ready to start recording
         */
        this.recordingReady = false;
        /**
         * Indicates whether the video is being recorded or not.
         */
        this.recording = false;
        (0, mobx_1.makeObservable)(this, {
            // observables
            recordingReady: mobx_1.observable,
            recording: mobx_1.observable,
            // actions
            setRecorder: mobx_1.action,
            removeRecorder: mobx_1.action,
            setupRecorder: mobx_1.action,
            record: mobx_1.action,
            pauseRecording: mobx_1.action,
            browserStopEvent: mobx_1.action,
            closeRecording: mobx_1.action,
            saveRecording: mobx_1.action,
            resetRecorder: mobx_1.action,
            setRecordingReady: mobx_1.action,
        });
        this.recorder = null;
        this.recordingReady = false;
        this.recording = false;
        this.resumeDisabled = false;
    }
    /**
     * Set recorder.
     * @description Sets the recorder to a new recorder instantiation.
     * @example <caption>Example usage of setRecorder.</caption>
     * setRecorder(recorder);
     * Updates uiState.recorder = recorder;
     */
    setRecorder(recorder) {
        this.recorder = recorder;
    }
    /**
     * Remove recorder.
     * @description Removes the recorder from context.
     * @example <caption>Example usage of removeRecorder.</caption>
     * removeRecorder();
     * Updates uiState.recorder = null;
     */
    removeRecorder() {
        this.recorder = null;
    }
    /**
     * Sets up new recorder context
     */
    async setupRecorder(startRecordingWhenClicked = true) {
        var _a;
        const res = await ((_a = this.recorder) === null || _a === void 0 ? void 0 : _a.setupRecorder());
        if (res.status === "error") {
            (0, mobx_1.runInAction)(() => {
                this.recording = false;
                this.recordingReady = false;
            });
        }
        if (startRecordingWhenClicked) {
            (0, mobx_1.runInAction)(() => {
                this.recording = true;
                this.recordingReady = true;
            });
        }
        else {
            (0, mobx_1.runInAction)(() => {
                this.recordingReady = true;
            });
        }
    }
    /**
     * Updates recorder context for recording status
     */
    async record() {
        var _a;
        const res = await ((_a = this.recorder) === null || _a === void 0 ? void 0 : _a.record());
        if (res.status === "error") {
            (0, mobx_1.runInAction)(() => {
                this.recording = false;
            });
        }
        (0, mobx_1.runInAction)(() => {
            this.recording = true;
        });
    }
    /**
     * Pauses recording
     */
    pauseRecording() {
        var _a;
        (0, mobx_1.runInAction)(() => {
            this.recording = false;
        });
        (_a = this.recorder) === null || _a === void 0 ? void 0 : _a.pause();
    }
    /**
     * Pauses recording
     */
    browserStopEvent() {
        var _a;
        (0, mobx_1.runInAction)(() => {
            this.recording = false;
            this.resumeDisabled = true;
        });
        (_a = this.recorder) === null || _a === void 0 ? void 0 : _a.pause();
    }
    /**
     * Stops recording
     */
    async closeRecording() {
        var _a, _b;
        if ((_a = this.recorder) === null || _a === void 0 ? void 0 : _a.stream) {
            await ((_b = this.recorder) === null || _b === void 0 ? void 0 : _b.close());
        }
        (0, mobx_1.runInAction)(() => {
            this.recording = false;
            this.recordingReady = false;
            this.recorder = null;
        });
    }
    /**
     * Stops recording
     */
    async saveRecording() {
        var _a;
        (0, mobx_1.runInAction)(() => {
            this.recording = false;
        });
        await ((_a = this.recorder) === null || _a === void 0 ? void 0 : _a.save());
        (0, mobx_1.runInAction)(() => {
            this.recordingReady = false;
        });
    }
    /**
     * Resets recording context
     */
    async resetRecorder() {
        (0, mobx_1.runInAction)(() => {
            this.recording = false;
            this.recordingReady = false;
            this.recorder = null;
        });
    }
    /**
     * Set recording ready
     */
    async setRecordingReady() {
        (0, mobx_1.runInAction)(() => {
            this.recordingReady = true;
        });
    }
}
RecorderUiState.displayName = "RecorderUiState";
exports.default = RecorderUiState;
//# sourceMappingURL=ui-state.js.map